import types from './types';

const INITIAL_STUDENT_FILTER = {
	grade: [],
	location: [],
	dorm: [],
	gender: [],
	type: []
}

const INITIAL_LEAVE_FILTER = {
	students: [],
	actors: [],
	type: [],
	leaveBy: [],
	returnBy: [],
	leaveAt: null,
	returnAt: null
}

export const INITIAL_FILTER = {
	student: INITIAL_STUDENT_FILTER,
	leaves: INITIAL_LEAVE_FILTER
}

const initialState = {
	loading: true,
	list: [],
	pinned: [],
	history: [],
	details: {},
	profile: {},
	students: [],
	missedFilters: INITIAL_LEAVE_FILTER,
	pendingFilters: INITIAL_LEAVE_FILTER,
	filters: {
		0: {
			student: INITIAL_STUDENT_FILTER,
			leaves: INITIAL_LEAVE_FILTER
		},
		1: {
			student: INITIAL_STUDENT_FILTER,
			leaves: INITIAL_LEAVE_FILTER
		},
		2: {
			student: INITIAL_STUDENT_FILTER,
			leaves: INITIAL_LEAVE_FILTER
		}
	},
	pendingMobileFilters: {
		student: {
			grade: [],
			location: [],
			dorm: [],
			gender: [],
			type: []
		},
		leaves: {
			students: [],
			actors: [],
			type: [],
			leaveBy: [],
			returnBy: [],
			leaveAt: null,
			returnAt: null
		}
	},
	returningMobileFilters: {
		student: {
			grade: [],
			location: [],
			dorm: [],
			gender: [],
			type: []
		},
		leaves: {
			students: [],
			actors: [],
			type: [],
			leaveBy: [],
			returnBy: [],
			leaveAt: null,
			returnAt: null
		}
	},
	leavingMobileFilters: {
		student: {
			grade: [],
			location: [],
			dorm: [],
			gender: [],
			type: []
		},
		leaves: {
			students: [],
			actors: [],
			type: [],
			leaveBy: [],
			returnBy: [],
			leaveAt: null,
			returnAt: null
		}
	}
};

// const filterKey = ['pendingMobileFilters','leavingMobileFilters', 'returningMobileFilters']


export default (state = initialState, action) => {
	// eslint-ignore-next-line
	switch (action.type) {
		/* Set initial list of items  */
		case types.UPDATE_LIST: {
			let newPostDetails = state.details
			const list = action.payload;
			list.forEach(doc => newPostDetails[doc.id] = doc)
			return {
				...state,
				loading: false,
				list: action.payload,
				details: newPostDetails
			};
		}

		case types.UPDATE_PINNED: {
			let newPinnedDetails = state.details
			const pinnedList = action.payload;
			pinnedList.forEach(doc => newPinnedDetails[doc.id] = doc)
			return {
				...state,
				loading: false,
				pinned: action.payload,
				details: newPinnedDetails
			};
		}

		case types.UPDATE_HISTORY: {
			let newPinnedDetails = state.details
			const pinnedList = action.payload;
			pinnedList.forEach(doc => newPinnedDetails[doc.id] = doc)
			return {
				...state,
				loading: false,
				history: action.payload,
				details: newPinnedDetails
			};
		}

		case types.CLEAR_LIST: {
			return initialState
		}

		case types.UPDATE_DETAILS: {
			return {
				...state,
				details: {...state.details, [action.payload.id]: action.payload}
			}
		}

		// Updates Filters for Mobile Airport Tabs
		case types.UPDATE_FILTER: {
			// let newFilters = state.filters
			const {filters, type, tab} = action.payload

			if(tab === 0){
				console.log('pending filter')
				const newFilter = {
					...state.pendingMobileFilters,
					[type]: filters
				}
				return {
					...state,
					pendingMobileFilters: newFilter
				}
			}
			else if(tab === 1){
				console.log('leaving filter')

				const newFilter = {
					...state.leavingMobileFilters,
					[type]: filters
				}
				return {
					...state,
					leavingMobileFilters: newFilter
				}
			}
			else if(tab === 2){
				console.log('returning filter')

				const newFilter = {
					...state.returningMobileFilters,
					[type]: filters
				}
				return {
					...state,
					returningMobileFilters: newFilter
				}
			}
			return state
		}
		// Clears Filters for Mobile Airport Tabs - type is either student or leaves
		case types.CLEAR_FILTER: {


			// let newFilters = state.filters
			const { type, tab} = action.payload
			let initial;
			if(type === 'student'){ initial = INITIAL_STUDENT_FILTER}
			else{initial = INITIAL_LEAVE_FILTER}
			if(tab === 0){
				console.log('pending filter')
				const newFilter = {
					...state.pendingMobileFilters,
					[type]: initial
				}
				return {
					...state,
					pendingMobileFilters: newFilter
				}
			}
			else if(tab === 1){
				console.log('leaving filter')

				const newFilter = {
					...state.leavingMobileFilters,
					[type]:  initial
				}
				return {
					...state,
					leavingMobileFilters: newFilter
				}
			}
			else if(tab === 2){
				console.log('returning filter')

				const newFilter = {
					...state.returningMobileFilters,
					[type]:  initial
				}
				return {
					...state,
					returningMobileFilters: newFilter
				}
			}
		break;
		}
		case types.UPDATE_MISSED_FILTER: {
			return {
				...state,
				missedFilters: action.payload
			}
		}
		case types.CLEAR_MISSED_FILTER: {
			return {
				...state,
				missedFilters: {
					students: [],
					actors: [],
					type: [],
					leaveBy: [],
					returnBy: [],
					leaveAt: null,
					returnAt: null
				}
			}
		}
		case types.UPDATE_PENDING_FILTER: {
			return {
				...state,
				pendingFilters: action.payload
			}
		}
		case types.CLEAR_PENDING_FILTER: {
			return {
				...state,
				pendingFilters: {
					students: [],
					actors: [],
					type: [],
					leaveBy: [],
					returnBy: [],
					leaveAt: null,
					returnAt: null
				}
			}
		}
		default:
			return state;
	}
};
